import React from "react";
import { useParams } from "react-router";
import { Heading, Loader, Popup } from "uikit/components";
import { useSchoolGroupsAttendance } from "hooks/attendance";
import { BackLink } from "components";
import styles from "./SchoolGroupsAttendancePage.module.styl";
import SchoolGroupsAttendanceView from "components/schoolSummary/SchoolGroupsAttendanceView/SchoolGroupsAttendanceView";
import { Flags } from "utils";
import { useContextPerson } from "hooks/persons";
import { Helmet } from "react-helmet-async";

export default function SchoolGroupsAttendancePage() {
    const { schoolId, regionId, municipalityId } = useParams();
    const { flags, isLoading: isContextLoading } = useContextPerson();
    const { isLoading, data } = useSchoolGroupsAttendance(schoolId);

    if (isLoading || isContextLoading) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text"/>
            </Popup>
        );
    }

    if (data) {
        return (
            <>
                <Helmet>
                    <meta
                        name="apple-mobile-web-app-title"
                        content={`Посещаемость: ${data.schoolName}`}
                    />
                    <meta name="application-name" content={`Посещаемость: ${data.schoolName}`} />
                </Helmet>
                {!flags?.[Flags.HideDashboardBackButton] && (
                    <BackLink
                        to={
                            regionId
                                ? `/attendance/region/${regionId}`
                                : municipalityId
                                ? `/attendance/municipality/${municipalityId}`
                                : `/school-summary/${schoolId}`
                        }
                        text={"Назад"}
                        name={"back_link"}
                    />
                )}
                <Heading size={"h1"} className={styles.heading} name="school-group-attendance-header">
                    Посещаемость: {data.schoolName}
                </Heading>
                <SchoolGroupsAttendanceView
                    groupsAttendance={data.groupsAttendance}
                    sportOrgUrl={data.sportOrgUrl}
                    schoolId={data.schoolId}
                />
            </>
        );
    }
}
